import { Input } from 'ohzi-core';
import { Time } from 'ohzi-core';
import { Math as TMath } from 'three';

import Transitioning from './Transitioning';

export default class Idle
{
  on_enter()
  {

  }

  update(wall_clicker)
  {
    let raycasted_wall = wall_clicker.walls_manager.raycasted_wall;

    if (raycasted_wall && Input.mouse_clicked())
    {
      wall_clicker.set_state(new Transitioning(raycasted_wall));
    }
  }

  on_exit(wall_clicker)
  {
    wall_clicker.walls_manager.is_wall_opened = true;
  }
}
